export default "__VITE_ASSET__CDLJxiT9__"